import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  FinanceIcon,

  AccountsReceivable1,
  AccountsReceivable2,
  AccountsReceivable3,
  AccountsPayable1,
  AccountsPayable2,
  AccountsPayable3,
  TaxationControls1,
  TaxationControls2,
  TaxationControls6,
} from '../../assets';

const FinancePage = () => {
  const productData = {
    productName: 'Finance',
    tagline: 'Complete Financial Control for Logistics',
    metaDescription: 'Freight finance software with GST, TDS, GSTR2B reconciliation, and bank reconciliation. Per-shipment P&L, approval workflows, and invoicing for freight forwarders.',
    description: 'Gain financial control with integrated Billing and Accounts Receivable. Track Invoices, manage Job/Non-Job billing, and access deep financial insights and ageing reports.',
    icon: FinanceIcon,
    features: [
      {
        title: 'Integrated Invoicing from Shipments',
        description: 'Generate invoices automatically from shipment data with accurate charge breakdowns.',
        image: AccountsReceivable1,
      },
      {
        title: 'Automated Collection Reminders',
        description: 'Send automated payment reminders and track collection status.',
        image: AccountsReceivable2,
      },
      {
        title: 'AR with Profitability Insights',
        description: 'Track receivables with built-in profitability analysis per customer and shipment.',
        image: AccountsReceivable3,
      },
      {
        title: 'Integrated Purchase Invoice Posting',
        description: 'Match vendor invoices with shipment costs and post to accounts payable.',
        image: AccountsPayable1,
      },
      {
        title: 'Bulk Purchase Booking System',
        description: 'Book multiple vendor invoices in bulk with automated validation.',
        image: AccountsPayable2,
      },
      {
        title: 'AP Tracking & Monitoring',
        description: 'Track payables aging, payment schedules, and vendor performance.',
        image: AccountsPayable3,
      },
      {
        title: 'Tax Automation Tools',
        description: 'Automate GST calculations, TDS deductions, and tax filing preparation.',
        image: TaxationControls1,
      },
      {
        title: 'Profit and Loss with EBITDA Metrics',
        description: 'View real-time P&L statements with EBITDA tracking at multiple levels.',
        image: TaxationControls2,
      },
      {
        title: 'Bank Reconciliation Suite',
        description: 'Reconcile bank statements automatically with matching algorithms.',
        image: TaxationControls6,
      },
    ],
    faqs: [
      {
        question: 'Can Shipmnts generate invoices automatically from shipment data?',
        answer: 'Yes. Shipmnts integrates billing directly with shipment operations: invoices are generated from job data with accurate charge breakdowns, eliminating manual re-entry and reducing billing errors.',
      },
      {
        question: 'Does Shipmnts support GST and TDS calculations for freight?',
        answer: 'Yes. Shipmnts automates GST calculations (including IGST, CGST, and SGST), TDS deductions, and tax filing preparation for freight invoices, tailored to Indian tax requirements.',
      },
      {
        question: 'Does Shipmnts support GSTR2B reconciliation?',
        answer: 'Yes. Shipmnts automates GSTR2B reconciliation by matching vendor invoices against GST returns data, identifying mismatches and reducing reconciliation time significantly.',
      },
      {
        question: 'Can I track profitability per shipment in Shipmnts?',
        answer: 'Yes. Shipmnts provides per-job P&L visibility with EBITDA-level metrics, letting you see revenue, costs, and margin on every shipment in real time.',
      },
      {
        question: 'Does Shipmnts have bank reconciliation?',
        answer: 'Yes. Shipmnts includes a bank reconciliation suite that matches bank statement entries against invoices and payments automatically, flagging unmatched items for review.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default FinancePage;
